import { customerConstants } from '../../_constants';
import { customerServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';
import { CustomerListExcel } from '../../../components/layout/CustomerExcel';

export const customerActions = {
    getAllCustomers,
    getActiveCustomers,
    getCustomers,
    loadCustomers,
    createCustomer,
    updateCustomer,
    getCustomerById,
    deleteCustomers,
    activation,
    sQSearchCust,
    sQSearchCustApprovedViewer,
    clearCustomers,
    searchSQShipperConsignee,
    clearSearchSQShipperConsignee,
    custCodeSearch,
    getCMDPayor,
    searchSQShipperConsigneeWithGroup,
    CustIsRatesCommodity,
    CustsqPerBag,
    getCustomerIdFromBase,
    isStrippingStuffing,
    GetCollectionPayor,
    getCustomerDetails,
    loadCustomersNew,
    shipperRatesCommodity,
    ratesCommodityNotNullCategory,
    computeInsurance,

    searchAeId,
};

function clearCustomers() { return { type: customerConstants.CLEAR_CUSTOMERS } }
function clearSearchSQShipperConsignee() { return { type: customerConstants.CLEAR_GOODS } }

function customerFetching() { return { type: customerConstants.CUSTOMER_FETCHING } }
function customerFetched() { return { type: customerConstants.CUSTOMER_FETCHED } }

function customerSubmitting() { return { type: customerConstants.CUSTOMER_SUBMITTING } }
function customerSubmitted() { return { type: customerConstants.CUSTOMER_SUBMITTED } }

function searchAeId() {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.searchAeId()
            .then(
                AEId => {
                    dispatch(success(AEId));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(AEId) { return { type: customerConstants.GET_AE_ID, AEId } }
}

function getAllCustomers(action) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getAllCustomers()
            .then(
                allCustomers => {
                    if (allCustomers.length > 0) {
                        if (action && action === 'download') {
                            CustomerListExcel(allCustomers)
                        }
                        else {
                            dispatch(success(allCustomers));
                        }
                        dispatch(customerFetched());
                    } else {
                        dispatch(alertActions.warning(allCustomers.message));
                        dispatch(customerFetched());
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(allCustomers) { return { type: customerConstants.GET_ALL_CUSTOMERS, allCustomers } }
}

function getActiveCustomers() {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getActiveCustomers()
            .then(
                activeCustomers => {
                    if (activeCustomers.length > 0) {
                        dispatch(success(activeCustomers));
                        dispatch(customerFetched());
                    } else {
                        dispatch(alertActions.warning(activeCustomers.message));
                        dispatch(customerFetched());
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(activeCustomers) { return { type: customerConstants.GET_ACTIVE_CUSTOMERS, activeCustomers } }
}
// Transaction
function getCustomers(skip, take, filter, search, customerCode) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getCustomers(skip, take, filter, search, customerCode)
            .then(
                customers => {
                    if (customers && customers.length > 0) {
                        dispatch(success(customers));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(customers) { return { type: customerConstants.GET_CUSTOMERS, customers } }
}
// Master Data
function loadCustomers(skip, take, filter, search) {
    return dispatch => {
        dispatch(customerFetching());
        dispatch(userActions.allowLeavePage());
        customerServices.loadCustomers(skip, take, filter, search)
            .then(
                customers => {
                    if (customers && customers.length > 0) {
                        dispatch(success(customers));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(customers) { return { type: customerConstants.GET_CUSTOMERS, customers } }
}
// NEW
function loadCustomersNew(payload) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.loadCustomersNew(payload)
            .then(
                customers => {
                    if (customers && customers.length > 0) {
                        dispatch(success(customers));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(customers) { return { type: customerConstants.GET_CUSTOMERS, customers } }
}

function createCustomer(payload) {
    return dispatch => {
        dispatch(customerSubmitting());
        dispatch(userActions.notallowLeavePage());
        customerServices.createCustomer(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(customerSubmitted());
                    dispatch(alertActions.success('Customer added successfully'))
                    window.location.href = '/master_data/customers';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(customerSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function updateCustomer(payload, id) {
    return dispatch => {
        dispatch(customerSubmitting());
        dispatch(userActions.notallowLeavePage());
        customerServices.updateCustomer(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(customerSubmitted());
                    dispatch(alertActions.success('Customer updated successfully'))
                    window.location.href = '/master_data/customers';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(customerSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function getCustomerById(code) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getCustomerById(code)
            .then(
                customer => {
                    dispatch(success(customer));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(customer) { return { type: customerConstants.GET_CUSTOMER_BY_ID, customer } }
}

function deleteCustomers(id, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        customerServices.deleteCustomers(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Customer deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/customers';
                            break;
                        default:
                            // dispatch(getCustomers(0, take));
                            let load = {
                                skip: 0,
                                take: take,
                                filter: "",
                                search: "",
                                isActive: true
                            }
                            dispatch(loadCustomersNew(load));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getCustomerById(id));
                            break;
                        default:
                            // dispatch(getCustomers(0, take));
                            let load = {
                                skip: 0,
                                take: take,
                                filter: "",
                                search: "",
                                isActive: true
                            }
                            dispatch(loadCustomersNew(load));
                            break;
                    }
                }
            );
    };
}

function activation(id, isActive, user) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        customerServices.activation(id, isActive, user)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getCustomerById(id));
                    dispatch(alertActions.success(isActive ? 'Customer activated successfully' : 'Customer deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getCustomerById(id));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function sQSearchCust(search) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.sQSearchCust(search)
            .then(
                customers => {
                    if (customers.length > 0) {
                        dispatch(success(customers));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning(customers.message))
                    }
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(customers) { return { type: customerConstants.GET_CUSTOMERS, customers } }
}
function sQSearchCustApprovedViewer(search) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.sQSearchCustApprovedViewer(search)
            .then(
                customers => {
                    if (customers.length > 0) {
                        dispatch(success(customers));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning(customers.message))
                    }
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(customers) { return { type: customerConstants.GET_CUSTOMERS, customers } }
}

function searchSQShipperConsignee(shipper, consignee) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.searchSQShipperConsignee(shipper, consignee)
            .then(
                ShipperConsignee => {
                    if (ShipperConsignee.length > 0) {
                        dispatch(success(ShipperConsignee));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning(ShipperConsignee.message))
                    }
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(ShipperConsignee) { return { type: customerConstants.GET_SHIPPER_CONSIGNEE, ShipperConsignee } }
}
function searchSQShipperConsigneeWithGroup(data) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.searchSQShipperConsigneeWithGroup(data)
            .then(
                ShipperConsigneeWithGroup => {
                    dispatch(success(ShipperConsigneeWithGroup));                 
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(ShipperConsigneeWithGroup) { return { type: customerConstants.SHIPPER_CONSIGNEE_GROUP, ShipperConsigneeWithGroup } }
}
function custCodeSearch(search) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.custCodeSearch(search)
            .then(
                SearchCustomer => {
                    if (SearchCustomer.length > 0) {
                        dispatch(success(SearchCustomer));
                        dispatch(customerFetched());
                    } else {
                        dispatch(customerFetched());
                        dispatch(alertActions.warning(SearchCustomer.message))
                    }
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(SearchCustomer) { return { type: customerConstants.SEARCH_CUSTOMER, SearchCustomer } }
}

function getCMDPayor(payload, search) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getCMDPayor(payload, search)
            .then(
                CustomerPayor => {
                    if (CustomerPayor && CustomerPayor.length) {
                        dispatch(success(CustomerPayor));
                        dispatch(customerFetched());
                    } else {
                        dispatch(alertActions.warning(CustomerPayor.message));
                        dispatch(customerFetched());
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(CustomerPayor) { return { type: customerConstants.GET_CUSTOMER_PAYOR, CustomerPayor } }
}

function CustIsRatesCommodity(data) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.CustIsRatesCommodity(data)
            .then(
                customerRateCommodity => {
                    dispatch(success(customerRateCommodity));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(customerRateCommodity) { return { type: customerConstants.CUSTOMER_RATES_COMMODITY, customerRateCommodity } }
}

function CustsqPerBag(data) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.CustsqPerBag(data)
            .then(
                customerSQPerBag => {
                    dispatch(success(customerSQPerBag));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(customerSQPerBag) { return { type: customerConstants.CUSTOMER_PER_BAG, customerSQPerBag } }
}

function getCustomerIdFromBase(payload) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getCustomerIdFromBase(payload)
            .then(
                customerFromBASE => {
                    dispatch(success(customerFromBASE));
                    dispatch(customerFetched());
                    // if (customerFromBASE && customerFromBASE.length > 0) {
                    //     dispatch(success(customerFromBASE));
                    //     dispatch(customerFetched());
                    // } else {
                    //     dispatch(customerFetched());
                    //     dispatch(alertActions.warning('No more data to load'))
                    // }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(customerFromBASE) { return { type: customerConstants.GET_CUSTOMER_FROM_BASE, customerFromBASE } }
}

function isStrippingStuffing(data) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.isStrippingStuffing(data)
            .then(
                StrippingStuffingCharge => {
                    dispatch(success(StrippingStuffingCharge));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(customerFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(StrippingStuffingCharge) { return { type: customerConstants.GET_STRIPPING_STUFFING, StrippingStuffingCharge } }
}
function GetCollectionPayor(shipper, consignee) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.GetCollectionPayor(shipper, consignee)
            .then(
                CollectionPayor => {
                    if (CollectionPayor && CollectionPayor.length) {
                        dispatch(success(CollectionPayor));
                        dispatch(customerFetched());
                    } else {
                        dispatch(alertActions.warning(CollectionPayor.message));
                        dispatch(customerFetched());
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(CollectionPayor) { return { type: customerConstants.GET_COLLECTION_PAYOR, CollectionPayor } }
}

function getCustomerDetails(payload) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.getCustomerDetails(payload)
            .then(
                CustomerDetail => {
                    dispatch(success(CustomerDetail));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(CustomerDetail) { return { type: customerConstants.GET_CUSTOMER_DETAILS, CustomerDetail } }
}

function shipperRatesCommodity(data) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.shipperRatesCommodity(data)
            .then(
                shipperCommodity => {
                    dispatch(success(shipperCommodity));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(shipperCommodity) { return { type: customerConstants.SHIPPER_COMMODITY, shipperCommodity } }
}

function ratesCommodityNotNullCategory(data) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.ratesCommodityNotNullCategory(data)
            .then(
                rateCommodityCategory => {
                    dispatch(success(rateCommodityCategory));                    
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(rateCommodityCategory) { return { type: customerConstants.CUSTOMER_RATE_COMMODITY_CATEGORY, rateCommodityCategory } }
}

function computeInsurance(payload) {
    return dispatch => {
        dispatch(customerFetching());
        customerServices.computeInsurance(payload)
            .then(
                comptInsurance => {
                    dispatch(success(comptInsurance));
                    dispatch(customerFetched());
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                    dispatch(customerFetched());
                }
            );
    };
    function success(comptInsurance) { return { type: customerConstants.COMPUTE_INSURANCE, comptInsurance } }
}